<div class="pop" [ngClass]="{'modeone': isModeOne}">
  <header>
    <svg width="37" height="41" viewBox="0 0 37 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.5 8.2C17.3694 8.2 16.4016 7.79854 15.5965 6.99562C14.7914 6.19271 14.3889 5.2275 14.3889 4.1C14.3889 2.9725 14.7914 2.00729 15.5965 1.20438C16.4016 0.401458 17.3694 0 18.5 0C19.6306 0 20.5984 0.401458 21.4035 1.20438C22.2086 2.00729 22.6111 2.9725 22.6111 4.1C22.6111 5.2275 22.2086 6.19271 21.4035 6.99562C20.5984 7.79854 19.6306 8.2 18.5 8.2ZM12.3333 41V14.35C10.2778 14.1792 8.18796 13.9229 6.06389 13.5812C3.93982 13.2396 1.91852 12.8125 0 12.3L1.02778 8.2C3.7 8.9175 6.54352 9.43854 9.55833 9.76313C12.5731 10.0877 15.5537 10.25 18.5 10.25C21.4463 10.25 24.4269 10.0877 27.4417 9.76313C30.4565 9.43854 33.3 8.9175 35.9722 8.2L37 12.3C35.0815 12.8125 33.0602 13.2396 30.9361 13.5812C28.812 13.9229 26.7222 14.1792 24.6667 14.35V41H20.5556V28.7H16.4444V41H12.3333Z" />
    </svg>
    <span class="accessibility_title" langkey="accessibility_title"></span>
  </header>
  <div class="content" [ngSwitch]="dialogView">
    <div *ngSwitchCase="'main'">
      <div class="bf-buttons">
        <button class="btn modeone-button" [ngClass]="{'modeone-active': isModeOne}" (click)="mode_one()">
          <div class="btn-icon">
            <svg width="37" height="41" viewBox="0 0 37 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18.5 8.2C17.3694 8.2 16.4016 7.79854 15.5965 6.99562C14.7914 6.19271 14.3889 5.2275 14.3889 4.1C14.3889 2.9725 14.7914 2.00729 15.5965 1.20438C16.4016 0.401458 17.3694 0 18.5 0C19.6306 0 20.5984 0.401458 21.4035 1.20438C22.2086 2.00729 22.6111 2.9725 22.6111 4.1C22.6111 5.2275 22.2086 6.19271 21.4035 6.99562C20.5984 7.79854 19.6306 8.2 18.5 8.2ZM12.3333 41V14.35C10.2778 14.1792 8.18796 13.9229 6.06389 13.5812C3.93982 13.2396 1.91852 12.8125 0 12.3L1.02778 8.2C3.7 8.9175 6.54352 9.43854 9.55833 9.76313C12.5731 10.0877 15.5537 10.25 18.5 10.25C21.4463 10.25 24.4269 10.0877 27.4417 9.76313C30.4565 9.43854 33.3 8.9175 35.9722 8.2L37 12.3C35.0815 12.8125 33.0602 13.2396 30.9361 13.5812C28.812 13.9229 26.7222 14.1792 24.6667 14.35V41H20.5556V28.7H16.4444V41H12.3333Z" />
          </svg>
          </div>
          <div class="btn-title">
            <span class="modeone_title" langkey="accessibility_modeone_title"></span>
          </div>
          <div class="btn-description">
            <span class="modeone_description" langkey="accessibility_modeone_desc"></span>
          </div>
          <div class="btn insert btn--add">
            <div inlineSVG="sot/sot-icon.svg#{{ isModeOne ? 'sot-done' : 'sot-play' }}" flex
              [setSVGAttributes]="{class: 'btn-icon'}"></div>
          </div>
        </button>
        <button class="btn modetwo-button" [ngClass]="{'modetwo-active': isModeTwo}" (click)="mode_two()">
          <div class="btn-icon">
          <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M22 44C18.9567 44 16.0967 43.4225 13.42 42.2675C10.7433 41.1125 8.415 39.545 6.435 37.565C4.455 35.585 2.8875 33.2567 1.7325 30.58C0.5775 27.9033 0 25.0433 0 22C0 18.9567 0.5775 16.0967 1.7325 13.42C2.8875 10.7433 4.455 8.415 6.435 6.435C8.415 4.455 10.7433 2.8875 13.42 1.7325C16.0967 0.5775 18.9567 0 22 0C25.0433 0 27.9033 0.5775 30.58 1.7325C33.2567 2.8875 35.585 4.455 37.565 6.435C39.545 8.415 41.1125 10.7433 42.2675 13.42C43.4225 16.0967 44 18.9567 44 22C44 25.0433 43.4225 27.9033 42.2675 30.58C41.1125 33.2567 39.545 35.585 37.565 37.565C35.585 39.545 33.2567 41.1125 30.58 42.2675C27.9033 43.4225 25.0433 44 22 44ZM24.2 39.435C28.5633 38.885 32.2208 36.9692 35.1725 33.6875C38.1242 30.4058 39.6 26.51 39.6 22C39.6 17.49 38.1242 13.5942 35.1725 10.3125C32.2208 7.03083 28.5633 5.115 24.2 4.565V39.435Z" />
          </svg>
          </div>
          <div class="btn-title">
            <span class="modetwo_title" langkey="accessibility_modetwo_title"></span>
          </div>
          <div class="btn-description">
            <span class="modetwo_description" langkey="accessibility_modetwo_desc"></span>
          </div>
          <div class="btn insert btn--add">
            <div inlineSVG="sot/sot-icon.svg#{{ isModeTwo ? 'sot-done' : 'sot-play' }}" flex
              [setSVGAttributes]="{class: 'btn-icon'}"></div>
          </div>
        </button>
      </div>
      <button class="btn show-accessibility-btn" (click)="dialogView = 'accessibility'">
        <span>{{buttonMoreInfoText}}</span>
      </button>
    </div>
    <div *ngSwitchCase="'accessibility'">
      <div class="accessibility-scrollbox">
        <div [innerHTML]="accessibilityHtml"></div>
      </div>
      <button class="btn show-accessibility-btn" (click)="dialogView = 'main'">
        {{buttonBackText}}
      </button>
    </div>
  </div>
  <footer class="buttons">
    <button mat-button class="btn goback insert" langkey="accessibility_button_back"
      (click)="closeAccessabiltydialog()">
    </button>
    <button *ngIf="isModeOne || isModeTwo" mat-button class="btn goforward"
      [ngClass]="{'modeone-active': isModeOne, 'modetwo-active': isModeTwo}" langkey="accessibility_button_confirm"
      (click)="setSelectedMode()">
    </button>
    <button
      *ngIf="!isModeOne && !isModeTwo && (accessibilityoptionsConfig.sot_service.Accessabilty.useModeOne || accessibilityoptionsConfig.sot_service.Accessabilty.useModeTwo)"
      mat-button class="btn reset" (click)="resetModes()" langkey="accessibility_button_reset">
    </button>
  </footer>
</div>